import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";

import VLFTextField from "@/components/Input/TextField";
import LoadingButton from "@mui/lab/LoadingButton";

import {AuthorizationAPI} from "@/api/authorization";

import {loginSuccess} from "@/actions";
import Logo from "@/assets/images/logo_white.png";

import "./index.scss";

const HIGHLIGHTS = [
	"Direzione, area tecnica, scouting, performance e area medica insieme",
	"Rose, gare, valutazioni e contratti sempre aggiornati e condivisi",
	"Ogni giorno le decisioni da prendere, già in ordine di priorità",
];

// Campo da gioco disegnato in trasparenza sul pannello di sinistra
function PitchLines() {
	return (
		<svg
			className="login-pitch"
			viewBox="0 0 680 1050"
			fill="none"
			aria-hidden="true"
		>
			<rect x="10" y="10" width="660" height="1030" rx="6" />
			<line x1="10" y1="525" x2="670" y2="525" />
			<circle cx="340" cy="525" r="92" />
			<circle cx="340" cy="525" r="5" />
			<rect x="138" y="10" width="404" height="165" />
			<rect x="248" y="10" width="184" height="55" />
			<path d="M267 175a92 92 0 0 0 146 0" />
			<rect x="138" y="875" width="404" height="165" />
			<rect x="248" y="985" width="184" height="55" />
			<path d="M267 875a92 92 0 0 1 146 0" />
		</svg>
	);
}

function LoginPage(props) {
	const {handleNotification} = props;

	const dispatch = useDispatch();
	const navigate = useNavigate();

	const isLoggedIn = useSelector((state) => state.isLoggedIn);

	useEffect(() => {
		if (isLoggedIn) {
			navigate("/");
		}
	}, [isLoggedIn, navigate]);

	const [formData, setFormData] = useState({username: "", password: ""});
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(false);

	const handleLogin = async () => {
		setLoading(true);
		try {
			const response = await AuthorizationAPI.login(formData);
			dispatch(loginSuccess(response.token));
			localStorage.setItem("token", response.token);
			navigate("/");
		} catch (error) {
			setError(true);
			handleNotification("Username e/o password non corretti", "error");
		} finally {
			setLoading(false);
		}
	};

	const handleChange = (event) => {
		const {name, value} = event.target;
		setError(false);
		setFormData({...formData, [name]: value});
	};

	const handleSubmit = (event) => {
		event.preventDefault();
		handleLogin();
	};

	return (
		<div className="login-page">
			<section className="login-brand">
				<PitchLines />
				<img className="login-brand__logo" src={Logo} alt="club OS" />
				<div className="login-brand__copy">
					<h1>Il sistema operativo del tuo club</h1>
					<p>Un'unica piattaforma per tutte le aree sportive del club.</p>
					<ul className="login-brand__list">
						{HIGHLIGHTS.map((item) => (
							<li key={item}>{item}</li>
						))}
					</ul>
				</div>
			</section>
			<main className="login-main">
				<form onSubmit={handleSubmit} className="login-form">
					<div className="login-form__headline">
						<h2>Bentornato</h2>
						<p>Entra con il tuo account per continuare.</p>
					</div>
					<VLFTextField
						name="username"
						value={formData.username}
						onChange={handleChange}
						label="Username"
						placeholder="Il tuo username"
						required
						error={error}
						inputProps={{autoComplete: "username"}}
					/>
					<VLFTextField
						name="password"
						value={formData.password}
						onChange={handleChange}
						type="password"
						label="Password"
						placeholder="La tua password"
						required
						error={error}
						inputProps={{autoComplete: "current-password"}}
					/>
					{error ? (
						<div className="login-form__error" role="alert">
							Controlla username e password e riprova.
						</div>
					) : null}
					<LoadingButton
						className="login-form__submit"
						fullWidth
						type="submit"
						variant="contained"
						loading={loading}
					>
						Accedi
					</LoadingButton>
					<p className="login-form__hint">
						Password dimenticata? Chiedi all'amministratore del club di
						reimpostarla.
					</p>
				</form>
			</main>
		</div>
	);
}

export default LoginPage;
